import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { altoQueryKeys } from "./queryKeys";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { ICRMBranch } from "./../../models/crm/CRMBranch";

export function useAltoBranches(agencyId: string) {
  const { get } = useApiHelper();

  const branches = useQuery({
    queryKey: altoQueryKeys.branches(agencyId),
    queryFn: () =>
      get(
        `/integration/alto/branches/${agencyId}`
      ) as unknown as IDefaultResponseWithData<ICRMBranch[]>,
    refetchOnWindowFocus: false,
  });

  return {
    branches,
  };
}
